<template>
<div class="card-body">

<!--  <div class="search-wrap">-->
<!--    <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>-->
<!--    <el-button size="mini" type="primary text2" @click="search">搜索</el-button>-->
<!--  </div>-->

  <div class="table-wrap">
    <el-table v-loading="loading" class="chat-table" :data="tableData">
      <el-table-column prop="id" label="ID" align="left" width="50"></el-table-column>
      <el-table-column prop="name" label="名称" align="center"></el-table-column>
      <el-table-column prop="article_ids_name" label="相关文章" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="180">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-edit" @click="editUser(scope.row)">修改</el-button>
<!--          <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteUser(scope.row)">删除</el-button>-->
        </template>
      </el-table-column>
    </el-table>
  </div>

  <div class="pagination-wrap">
    <el-pagination background layout="prev, pager, next" :total="total" :page-size="pageSize" :current-page="page" @current-change="pageChange"></el-pagination>
  </div>

  <!-- 修改窗口 -->
  <el-dialog title="分组编辑" :visible.sync="dialogVisible" width="600px">
    <el-form :model="form" :rules="rules" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
      <el-form-item label="名称" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="文章" prop="article_ids">
<!--        <el-input v-model="form.article_ids" autocomplete="off"></el-input>-->
        <el-select
          v-model="form.article_ids"
          multiple
          filterable
          remote
          reserve-keyword
          placeholder="请输入文章"
          :remote-method="getArticle"
          :loading="loading">
          <el-option
            v-for="item in articleTableData"
            :key="item.id"
            :label="item.title"
            :value="(item.id*1)">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm('form')" :loading="formLoading">确 定</el-button>
    </div>
  </el-dialog>

</div>
</template>

<script>

  import { Loading } from 'element-ui';
  import { User, UserGroup } from './common.js'
  import xhHelp from "./xhHelp";

export default {
  name: "CardUserGroup",
  data () {
    return {
      is_internal: '',
      group_id: '',
      keyword: '',
      loading: false,
      tableData: [],
      groupList: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      formLoading: false,
      form: {
        id: '',
        name: '',
        article_ids: '',
      },
      rules: {
        // name: [
        //   { required: true, message: '请填写姓名', trigger: 'blur' },
        // ],
        // phone: [
        //   { required: true, message: '请填写手机号码', trigger: 'blur' },
        // ],
        // is_internal: [
        //   { required: true, message: '请选择是否内部成员', trigger: 'change' },
        // ],
        // group_id: [
        //   { required: true, message: '请选择分组', trigger: 'change' },
        // ],
      },
      articleTableData:[],
      articleKeyword:""
    }
  },
  created() {

    UserGroup.getList(res => {
      if(res.code == 0) {
        this.groupList = res.data.data
      }
    })

    this.getList()

  },
  methods: {
    search() {
      this.page = 1
      this.getList()
    },
    getList() {
      // User.getList({keyword: this.keyword, page: this.page, page_size: this.pageSize}, res => {
      //   if(res.code == 0) {
      //     this.total = res.data.total
      //     this.tableData = res.data.data
      //   }
      // })
      xhHelp.get("userGroup/getList",{keyword: this.keyword, page: this.page, page_size: this.pageSize},res => {
        if(res.code == 0) {
          this.total = 0
          this.tableData = res.data.map(ret=>{
            ret.article_ids_name=ret.article_ids
            if(ret.article_ids){
              ret.article_ids=ret.article_ids.split(",").map(ret=>{ return ret*1 })
            }
            return ret;
          })
        }
      })

    },
    pageChange(i) {
      this.page = i
      this.getList()
    },
    editUser(item) {

      let data = {}
      for(let k in this.form) {
        data[k] = item[k]
      }
      data.article_ids.length===0&&(data.article_ids="")
      this.form = data
      this.getArticle("",item.article_ids_name)
      //console.log(this.form)

      this.dialogVisible = true
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.formLoading = true
          let data = Object.assign({}, this.form)
          data.article_ids=data.article_ids.join(',')
          xhHelp.post("userGroup/saveGroup",data,res => {
            this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
            if(res.code == 0) {
              this.dialogVisible = false
              this.getList()
            }
            this.formLoading = false
          })

        } else {
          return false;
        }
      });
    },
    deleteUser(item) {

      this.$confirm('此操作将删除该会员['+item.phone+'], 是否继续?', '提示', {type: 'warning'}).then(() => {
        User.delete(item.id, res => {
          this.$message({type: res.code == 0 ? 'success': 'error', message: res.msg})
          if(res.code == 0) {
            this.getList()
          }
        })
      })

    },
    getArticle(articleKeyword,ids=""){
      xhHelp.get("Article/getList",{keyword: articleKeyword,ids:ids, page: 1, page_size: 50},res => {
        if(res.code == 0) {
          this.articleTableData = res.data.data
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>

  @import './common.scss';

</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Card/UserGroup.vue